import * as React from 'react';

const AwardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path d="m12.072 28.31-2.225-3.794-4.341-.88.438-4.361-2.815-3.272 2.815-3.264-.438-4.336 4.34-.905 2.226-3.803 3.929 1.734 3.928-1.734 2.259 3.803 4.333.905-.464 4.336 2.816 3.264-2.816 3.272.464 4.361-4.333.88-2.26 3.795-3.927-1.734-3.929 1.734Zm.465-1.35L16 25.535l3.512 1.423 2.08-3.256 3.772-.897-.349-3.89 2.572-2.913-2.572-2.928.349-3.916-3.772-.856-2.095-3.256-3.497 1.423-3.513-1.423-2.08 3.256-3.771.856.348 3.916-2.571 2.928 2.571 2.913-.348 3.905 3.771.882 2.129 3.256Zm2.056-7.293 6.618-6.577-.782-.7-5.836 5.82-3.013-3.094-.79.782 3.803 3.77Z" />
    </g>
  </svg>
);
export default AwardIcon;
